import { handleClickAddOnBtn, handleToggleAddOnCheck } from './handleToggleAddOn'
import handleOpenModalLatitude from './handleOpenModalLatitude'
import stickySummary from '../components/plan-summary/sticky'
import deleteLatitude from './deleteLatitude'
import deleteDental from './deleteDental'
import handleToggleSupplement from './handleToggleSupplement'
import handleOpenModalDental from './handleOpenModalDental'
import handleToggleExtended from './handleToggleExtended'
import deleteSupplemental from './deleteSupplemental'
import clickEventName from 'utils/DOM/clickEventName'
import toggleMenu from './toggleMenu'
import addPlanId from './addPlanId'
import handleToggleVision from './handleToggleVision'
import { preventOnCloseEvent } from 'core/services/onClose'
import toggleClass from 'utils/DOM/toggleClass'
import deleteVision from './deleteVision'

function registryListenersDOM() {
  $('body')
    .on(clickEventName, '.add-plan', addPlanId)
    .on(clickEventName, '.add-plan', function () {
      preventOnCloseEvent()
    })
    .on(
      clickEventName,
      '.add-plan-anchored',
      { anchor: '#detail--optional-benefit-coverage' },
      addPlanId
    )
    .on(clickEventName, '.eligibility-link--sticky', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.ProgressBar__link', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.js-menu', toggleMenu)
    .on(clickEventName, '.js-latitude-delete', deleteLatitude)
    .on(clickEventName, '.js-addon-delete', deleteDental)
    .on(clickEventName, '.js-vision-delete', deleteVision)
    .on(clickEventName, '.js-supplemental-delete', deleteSupplemental)
    .on(clickEventName, '.js-modal', handleOpenModalDental)
    .on(clickEventName, '.js-modal-latitude', handleOpenModalLatitude)
    .on(clickEventName, '#extended-plan', handleToggleExtended)
    .on(clickEventName, '.js-add-on-btn', handleClickAddOnBtn)
    .on(clickEventName, '.js-latitude-btn', handleClickAddOnBtn)
    .on('change', '.js-supplement-input', handleToggleSupplement)
    .on('change', '.js-add-on', handleToggleAddOnCheck)
    .on('change', '.js-latitude', handleToggleAddOnCheck)
    .on('change', '#vision-checkbox', handleToggleVision)
    .on(clickEventName, '.plan-switch__skip', () =>
      toggleClass('.plan-switch__wrap', 'd-none', true)
    )

  $('#plan-card__details-collapse')
    .on('shown.bs.collapse', stickySummary)
    .on('hidden.bs.collapse', stickySummary)
}

export default registryListenersDOM
